import { createRouter, createWebHistory } from 'vue-router'
import HomePage from './views/HomePage.vue'



export default createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomePage
    },


    {
      path: '/sogi',
      name: 'sogi-form',
      component: () => import('./views/BioDataForm.vue')
    },
    {
      path: '/sogi/admin',
      name: 'sogi-admin',
      component: () => import('./views/adminBioData.vue')
    },
    {
      path: '/so-options',
      name: 'so-options',
      component: () => import('./views/soOptions.vue')
    },
    {
      path: '/gi-options',
      name: 'gi-options',
      component: () => import('./views/giOptions.vue')
    },


    {
      path: '/legal-sex',
      name: 'legal-sex-form',
      component: () => import('./views/LegalSexForm.vue')
    },
    {
      path: '/race-ethnicity',
      name: 'race-ethnicity-form',
      component: () => import('./views/RaceEthnicityForm.vue')
    },
    {
      path: '/disability',
      name: 'disability-form',
      component: () => import('./views/DisabilityForm.vue')
    },
    {
      path: '/veteran',
      name: 'veteran-form',
      component: () => import('./views/VeteranForm.vue')
    },
    {
      path: '/parent',
      name: 'parent-form',
      component: () => import('./views/StudentParentForm.vue')
    },
    {
      path: '/address',
      name: 'address-form',
      component: () => import('./views/AddressForm.vue')
    },
    {
      path: '/preferred-name',
      name: 'preferred-name-form',
      component: () => import('./views/PreferredNameForm.vue')
    },
    {
      path: '/external-email',
      name: 'external-email-form',
      component: () => import('./views/ExternalEmailForm.vue')
    },
    {
      path: '/tribal-affiliation',
      name: 'tribal-affiliation-form',
      component: () => import('./views/TribalAffiliationForm.vue')
    },
    

    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: HomePage
    },
  ]
})
